import React from "react"
import PropTypes from "prop-types"
import { Grid } from "@bw/bits"

const Teasers = ({ displayType, numberOfColumns, children }) => {
  switch (displayType) {
    case "carousel":
    case "grid":
    default:
      return (
        <Grid columns={numberOfColumns} gap="large">
          {children}
        </Grid>
      )
  }
}

Teasers.propTypes = {
  displayType: PropTypes.oneOf(["grid", "carousel"]),
  numberOfColumns: PropTypes.number,
}

Teasers.defaultProps = {
  numberOfColumns: 3,
  displayType: "grid",
}

export { Teasers }
